<template>
    <b-modal ref="mdlConfigurazioneMagazzinoCategoriaArticoli" :title="title" centered no-close-on-backdrop no-close-on-esc hide-header-close size="lg">
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Azienda</label>
                <span v-if="isReadOnly"> {{ jsonDataCategoriaArticolo.codiceAzienda }} </span>
                <b-form-input v-else v-model="jsonDataCategoriaArticolo.codiceAzienda"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                <label class="sa-label-data">Categoria</label>
                <span v-if="isReadOnly"> {{ jsonDataCategoriaArticolo.categoria }}</span>
                <b-form-input v-else v-model="jsonDataCategoriaArticolo.categoria"></b-form-input>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Note</label>
                <span v-if="isReadOnly">{{ jsonDataCategoriaArticolo.note }}</span>
                <b-textarea v-else v-model="jsonDataCategoriaArticolo.note" max-rows="10" rows="7"></b-textarea>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button v-if="!isReadOnly" size="md" variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button v-if="!isReadOnly" size="md" variant="outline-success" @click="onClickSalvaCategoriaArticolo">Salva</b-button>
            <b-button v-if="isReadOnly" size="md" variant="outline-secondary" @click="onCloseModal">Chiudi</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
export default {
    name: "ConfigurazioniMagazzinoArticoliCategoriaModalEditComponent",
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            pathResource: "/magazzinoarticolicategorie",
            isReadOnly: false,
            jsonDataCategoriaArticolo: {
                id: null,
                codiceAzienda: null,
                categoria: null,
                note: null,
            },
        };
    },
    mounted() {
        console.log("Componente attivo");
    },
    methods: {
        show(jsonDataCategoriaArticolo, isReadOnly) {
            let me = this;
            me.jsonDataCategoriaArticolo = jsonDataCategoriaArticolo;
            me.isReadOnly = isReadOnly;
            if (isReadOnly) {
                me.title = "Visualizzazione Categoria";
            } else {
                me.title = !jsonDataCategoriaArticolo.id ? "Nuova Categoria" : "Aggiorna Categoria";
            }
            me.$refs.mdlConfigurazioneMagazzinoCategoriaArticoli.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataCategoriaArticolo = {
                id: null,
                codiceAzienda: null,
                categoria: null,
                note: null,
            };
            me.$emit("onCloseModal");
            me.$refs.mdlConfigurazioneMagazzinoCategoriaArticoli.hide();
        },
        onClickSalvaCategoriaArticolo() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataCategoriaArticolo, me.salvaCategoriaArticoloSuccess, me.salvaCategoriaArticoloError);
        },
        salvaCategoriaArticoloSuccess(response) {
            let me = this;
            me.$emit("saveCategoriaArticolo", response);
            me.$refs.mdlConfigurazioneMagazzinoCategoriaArticoli.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        salvaCategoriaArticoloError(error) {
            let me = this;
            me.$emit("saveCategoriaArticolo", error);
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onDeleteCategoriaArticolo(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di eliminare questa configurazione?", {
                    title: "Eliminazione Categoria",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteCategoriaArticolo(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteCategoriaArticolo(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResourceCategoriaArticoli + "/" + id, null, me.deleteCategoriaArticoloSuccess, me.deleteCategoriaArticoloError);
        },
        deleteCategoriaArticoloSuccess(response) {
            let me = this;
            me.$emit("categoriaArticoloDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteCategoriaArticoloError(response) {
            let me = this;
            me.$emit("categoriaArticoloDelete", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
    },
};
</script>
